import TrashIconTwo from "src/assets/images/TrashTwo.svg";
import search from "src/assets/images/search.svg";
import file from "src/assets/images/file.svg";

interface SingleFileCardProps {
    fileUrl: string;
    onPreview?: (url: string) => void;
    onDelete?: (url: string) => void;
    additional?: boolean; // Optional prop to indicate if this is an additional file
}

export default function SingleFileCard({ fileUrl, onPreview, onDelete, additional }: SingleFileCardProps) {
    const fileName = decodeURIComponent(fileUrl.split("/").pop() || "Unnamed File");

    return (
        <div className={`border border-[#D7D7D7] rounded-xl p-2 flex items-center justify-between max-w-md w-full mb-2 ${additional ? "bg-orange-50" : ""}`}>
            <div className="flex items-center space-x-3 overflow-hidden">
                {/* File Icon */}
                <img src={file} alt="file icon" className="w-3 h-3" />
                <span className="text-gray-800 text-sm font-medium truncate whitespace-nowrap overflow-hidden max-w-[200px]">
                    {fileName}
                </span>
            </div>

            <div className="flex items-center space-x-4">
                {/* <img
                    src={search}
                    alt="Preview"
                    onClick={() => onPreview?.(fileUrl)}
                    className="w-3 h-3 cursor-pointer"
                /> */}
                <img
                    src={TrashIconTwo}
                    alt="Delete"
                    onClick={() => onDelete?.(fileUrl)}
                    className="w-3 h-3 cursor-pointer"
                />
            </div>
        </div>
    );
}
